module.exports = __webpack_public_path__ + "static/media/IMG_2608.a23f1ca8.JPG";